export default __webpack_public_path__ + "73b76bf35df3be903b0f2e40aed5de4c.svg";